export const STOERK_ID_ASYNC_SLICE_NAME_REDUCER = 'stoerkIdAsyncThunk';
export const DELETE_DEVICE_IN_WHOLE_WORKSPACE_ACTION = `${STOERK_ID_ASYNC_SLICE_NAME_REDUCER}/deleteDeviceInWholeWorkspace`;
